module.exports = __webpack_public_path__ + "img/newswiper_1.1f8defe5.png";